
const quotaExceededError     = 'QuotaExceededError'.toLowerCase();
const localStorageTypeName   = 'localStorage';
const sessionStorageTypeName = 'sessionStorage';
const stringType             = 'string';
const numberType             = 'number';
const booleanType            = 'boolean';

export class SimpleStorage
{
    constructor(useSessionStorage)
    {
        this._storage     = window.localStorage;
        this._storageType = localStorageTypeName;

        let storageType = localStorageTypeName;

        if (   typeof useSessionStorage === booleanType
            && useSessionStorage
        )
        {
            storageType = sessionStorageTypeName;
        }

        if (SimpleStorage.isStorageTypeAvailable(storageType))
        {
            if (storageType === sessionStorageTypeName)
            {
                this._storage = window.sessionStorage;
            }

            this._storageType = storageType;
        }
        else
        {
            this._storage     = new WebMemoryStorage();
            this._storageType = 'WebMemoryStorage';
        }

        this.clear      = this.clear.bind(this);
        this.getItem    = this.getItem.bind(this);
        this.key        = this.key.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.setItem    = this.setItem.bind(this);
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Testing_for_availability
    // TODO: Enable private class members using '#' syntax
    static isStorageTypeAvailable(type)
    {
        const storage   = window[type];
        let isAvailable = false;

        try
        {
            if (storage)
            {
                const x = '__storage_test__';
                if (storage.length > 0)
                {
                    isAvailable = true;
                }
                else
                {
                    const originalLength = storage.length;
                    storage.setItem(x, x);
                    const currentLength = storage.length;
                    if (currentLength > originalLength)
                    {
                        storage.removeItem(x);
                        isAvailable = true;
                    }
                }
            }
        }
        catch(e)
        {
            if (storage)
            {
                isAvailable = e instanceof DOMException
                    && (
                        // everything except Firefox
                        e.code === 22
                        // Firefox
                        || e.code === 1014
                        // test name field too, because code might not be present
                        // everything except Firefox
                        || e.name.toLowerCase() === quotaExceededError
                        // Firefox
                        || e.name.toUpperCase() === 'NS_ERROR_DOM_QUOTA_REACHED'
                    )
                    // acknowledge QuotaExceededError only if there's something already stored
                    && storage.length !== 0
                ;
            }
        }

        return isAvailable;
    }

    clear()
    {
        this._storage.clear();
    }

    getItem(keyName)
    {
        let value = null;
        if (typeof keyName === stringType)
        {
            value = this._storage.getItem(keyName);
        }

        return value;
    }

    key(index)
    {
        let value = null;
        if (   typeof index === numberType
            && index >= 0
        )
        {
            value = this._storage.key(index);
        }

        return value;
    }

    get length()
    {
        return this._storage.length;
    }

    removeItem(keyName)
    {
        if (typeof keyName === stringType)
        {
            try
            {
                this._storage.removeItem(keyName);
            }
            catch(e)
            {
                // Ignore this error
            }
        }
    }

    setItem(keyName, keyValue)
    {
        if (   keyValue
            && typeof keyName === stringType
        )
        {
            try
            {
                this._storage.setItem(keyName, keyValue);
                this.getItem(keyName);
            }
            catch(e)
            {
                // Ignore this error
            }
        }
    }
}


class WebMemoryStorage
{
    constructor()
    {
        this.clear      = this.clear.bind(this);
        this.getItem    = this.getItem.bind(this);
        this.key        = this.key.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.setItem    = this.setItem.bind(this);

        this._storage = new Object();
    }

    clear()
    {
        this._storage = new Object();
    }

    getItem(keyName)
    {
        let value = null;
        if (typeof keyName === stringType)
        {
            value = this._storage[keyName];
        }

        return value;
    }

    key(index)
    {
        let value = null;
        if (   typeof index === numberType
            && index >= 0
        )
        {
            value = Object.values(this._storage)[index];
        }

        return value;
    }

    get length()
    {
        return Object.keys(this._storage).length;
    }

    removeItem(keyName)
    {
        if (typeof keyName === stringType)
        {
            delete this._storage[keyName];
        }
    }

    setItem(keyName, keyValue)
    {
        if (typeof keyName === stringType)
        {
            try
            {
                this._storage[keyName] = keyValue;
                this.getItem(keyName);

            }
            catch(e)
            {
                // Ignore this error
            }
        }
    }
}
